import React, { FC, useState } from "react";
import { Spin } from "antd";

// Microsoft logo SVG component - official colors
const MicrosoftLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 23 23"
  >
    <rect x="1" y="1" width="10" height="10" fill="#f35325" />
    <rect x="12" y="1" width="10" height="10" fill="#81bc06" />
    <rect x="1" y="12" width="10" height="10" fill="#05a6f0" />
    <rect x="12" y="12" width="10" height="10" fill="#ffba08" />
  </svg>
);

const OfficeLoginBtn: FC = () => {
  const [loading, setLoading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const signInUser = (pathName: string) => {
    const baseUrl = process.env.REACT_APP_BASE_URL as string;
    const isLocalhost = baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1');
    const protocol = isLocalhost ? 'http://' : 'https://';
    const cleanBaseUrl = baseUrl.replace(/^https?:\/\//, '');
    const redirectTo = `${protocol}${cleanBaseUrl}/${pathName}?path=finishSignup`;
    window.location.href = redirectTo;
  };

  const handleOfficeAuth = () => {
    const path = process.env.REACT_APP_OFFICE_AUTH_ENDPOINT;
    setLoading(true);
    if (path) signInUser(path);
  };

  const getBackgroundColor = () => {
    if (isPressed) return '#e9e9e9';
    if (isHovered) return '#f2f2f2';
    return '#ffffff';
  };

  return (
    <button
      onClick={handleOfficeAuth}
      disabled={loading}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { setIsHovered(false); setIsPressed(false); }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      style={{
        width: '100%',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        border: '1px solid #8c8c8c',
        borderRadius: '4px',
        background: getBackgroundColor(),
        transition: 'background 0.1s ease, border-color 0.1s ease',
        cursor: loading ? 'wait' : 'pointer',
        fontFamily: '"Segoe UI", "Segoe UI Web (West European)", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
        fontSize: '15px',
        fontWeight: 600,
        color: '#5e5e5e',
        outline: 'none',
        padding: '0 12px',
      }}
    >
      {loading ? (
        <Spin size="small" />
      ) : (
        <>
          <MicrosoftLogo />
          <span>Sign in with Microsoft</span>
        </>
      )}
    </button>
  );
};

export default OfficeLoginBtn;
